import { render, staticRenderFns } from "./LeadsAccess.vue?vue&type=template&id=5ba02118&scoped=true"
import script from "./LeadsAccess.vue?vue&type=script&lang=js"
export * from "./LeadsAccess.vue?vue&type=script&lang=js"
import style0 from "./LeadsAccess.vue?vue&type=style&index=0&id=5ba02118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba02118",
  null
  
)

export default component.exports